import styled from 'styled-components';
import { Upload } from 'antd';

import { tangerineGradient } from '../../styles';

export const UploadS = styled(Upload)`
  margin-bottom: 15px;
  cursor: pointer;
`;

export const AvatarImage = styled.img`
  width: ${({ width = 90 }) => `${width}px`};
  height: ${({ height = 90 }) => `${height}px`};
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid ${props => props.theme.colors.borderOrange}
`;

export const ChoosePhoto = styled.div`
  ${tangerineGradient};
  height: 90px;
  width: 90px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ChoosePhotoPlus = styled.span`
  line-height: 1;
  color: ${props => props.theme.colors.white};
  font-size: 34px;
`;

export const ChoosePhotoText = styled.span`
  text-align: center;
  font-size: 11px;
  color: ${props => props.theme.colors.white};
  line-height: 1.3;     
;
`;



// WEBPACK FOOTER //
// ./src/components/avatar/styled-components.js